import { GrayscalePalette } from '@tcl-boron-colors/colors';

const minHeight = 640;
const styles = {
  root: {
    display: 'flex',
    position: 'relative',
    maxHeight: '100%',
  },
  left: {
    flex: 1,
    display: 'flex',
    minWidth: '480px', // necessary for IE
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '40px',
    background: GrayscalePalette[5],
    borderRight: `1px solid ${GrayscalePalette[10]}`,
    boxShadow: '0 2px 4px 0 rgba(224, 224, 224, 0.5)',
    transition: 'opacity 0.5s',
    fontSize: '14px',
    minHeight: '100vh',
    '& h1': {
      fontWeight: 300,
    },
    '@media (max-width: 1200px)': {
      width: '400px',
    },
    [`@media (max-height: ${minHeight + 10}px)`]: {
      justifyContent: 'initial',
      padding: '0 40px 40px',
    },
    '@media (max-width: 900px)': {
      width: '100%',
      minWidth: '100%',
    },
  },
  widgetContainer: {
    width: '100%',
    flexGrow: 1,
    flexDirection: 'column',
    display: 'flex',
  },
  logoContainer: {
    marginTop: '10px',
  },
  pageContainer: {
    width: '100%',
    flex: 1,
    minHeight: 0,
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
  },
  rightContainer: {
    backgroundColor: '#F9F9FA',
    backgroundSize: 'cover',
    width: '100%',
    maxHeight: '100vh',
    textAlign: 'center',
  },
  video: {
    maxHeight: '57%',
    maxWidth: '57%',
  },
  right: {
    flex: 1,
    minWidth: 'calc(100vw - 500px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    transition: 'opacity 1s, transform 1s',
    '& h1': {
      margin: '10px 0',
      fontWeight: 300,
    },
    '@media (max-width: 1200px)': {
      width: 'calc(100vw - 400px)',
    },
    '@media (max-width: 900px)': {
      display: 'none',
    },
  },
  show: {
    opacity: 1,
  },
  hide: {
    opacity: 0,
    transform: 'translateY(15px)',
  },
  logo: {
    flexShrink: 0,
    height: '25px',
    width: '150px',
  },
  contact: {
    margin: '1rem',
    padding: '2rem 2rem',
    textAlign: 'center',
  },
  contactInfo: {
    display: 'inline-block',
    padding: '1rem 1rem',
    verticalAlign: 'middle',
    color: '#29293d', //ActionPalette600
  },
  deviceImages: {
    marginTop: '50px',
    position: 'relative',
    '& svg': {
      width: '45vw',
    },
    '& img': {
      width: '25%',
      position: 'absolute',
      left: 0,
      bottom: '35px',
    },
  },
  badgeGoogle: {
    display: 'flex',
    '& svg': {
      flexShrink: 0,
      margin: '0 5px',
      transition: 'opacity 0.2s',
      bottom: '32px',
      right: '32px',
      position: 'absolute',
    },
    '& svg:hover': {
      opacity: 0.85,
    },
  },
  badgeApple: {
    display: 'flex',
    '& svg': {
      flexShrink: 0,
      margin: '0 5px',
      transition: 'opacity 0.2s',
      bottom: '32px',
      right: '184px',
      position: 'absolute',
    },
    '& svg:hover': {
      opacity: 0.85,
    },
  },
  appDashboardContainer: {
    fontSize: '10px',
  },
  emptyAppState: {
    textAlign: 'center',
  },
  noAccessImage: {
    maxWidth: '100%',
  },
  chooseYourApplication: {
    paddingLeft: '46px',
    maxWidth: 'calc(490px - 46px)',
  },
  chooseYourApplicationText: {
    textAlign: 'left',
  },
  loadingContainer: {
    width: '100%',
    flex: 1,
    alignSelf: 'stretch',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  startOverButton: {
    fontSize: '12px',
  },
};

export default styles;
